import React, { useEffect, useCallback, useState, memo } from 'react';
import debounce from 'lodash/debounce';
import { TextInput, TextInputProps, ControlProps } from 'lego-on-react';

export const TextInputEnhanced = memo(function TexInputDebounced(
    props: Readonly<TextInputProps & ControlProps & { wait?: number; escapeSpecialChars?: boolean }>,
) {
    const { escapeSpecialChars, text, onChange, wait = 500 } = props;
    const [inputValue, setInputValue] = useState<string | undefined>();
    useEffect(() => {
        setInputValue(String(text));
    }, [text]);
    const onChangeDebounced = useCallback(debounce(onChange || (() => {}), wait), [onChange]);
    const onInputChange = (updatedValue: string) => {
        if (escapeSpecialChars && /[$&+~,:;=?@#|/'"`<>.\\^*()%! ]/.test(updatedValue)) return;
        setInputValue(updatedValue);
        onChangeDebounced(updatedValue);
    };

    return <TextInput {...props} text={inputValue} onChange={onInputChange} />;
});
